/* global gdAlertify */
import React, { useState, useEffect } from "react";
import axiosInstance from "../../config/axiosConfig";
import { cleanRut, validateRut, formatRut } from '../../utils/rut';
import { formatSectorLabel } from "../../utils/utils";
import Select from 'react-select';
import { useNavigate, useParams } from 'react-router-dom';
import HorasTurnoModal from "../components/HorasTurnoModal";



const usoTutorPacienteOptions = [
    { value: 0, label: 'No' },
    { value: 1, label: 'Si' }
];

const facturaAOptions = [
    { value: 'paciente', label: 'Paciente' },
    { value: 'tutor', label: 'Tutor' },
    { value: 'otro', label: 'Otro' }
];

const GLOSA_DEFAULT = "ATENCION EN DOMICILIO {periodo}";

// Marca visual de campo obligatorio en los labels del formulario.
const Requerido = () => <span className="text-danger">*</span>;

const sectorOptions = [1, 2, 3, 4, 5].map((sector) => ({
    value: `Sector ${sector}`,
    label: `Sector ${sector}`,
}));

const findSectorOption = (sectorValue) => {
    const value = String(sectorValue || "").trim().toLowerCase();
    return sectorOptions.find(option => option.value.toLowerCase() === value || option.value.toLowerCase() === `sector ${value}`) || null;
};

const PacienteResumen = ({ datosPaciente, comunas }) => {
    const nombreCompleto = [
        datosPaciente.nombres,
        datosPaciente.apellidoPaterno,
        datosPaciente.apellidoMaterno,
    ].filter(Boolean).join(" ");
    const comunaSeleccionada = comunas.find((option) =>
        String(option.value) === String(datosPaciente.comuna) ||
        String(option.label).toLowerCase() === String(datosPaciente.comuna || "").toLowerCase()
    );

    const items = [
        { label: "Paciente", value: nombreCompleto || "-" },
        { label: "RUT", value: datosPaciente.rut || "-" },
        { label: "Ingreso SK", value: datosPaciente.fecha_ingreso_sk || "-" },
        { label: "Sector", value: formatSectorLabel(datosPaciente.sector) },
        { label: "Diagnóstico", value: datosPaciente.diagnostico || "-" },
        { label: "Comuna", value: comunaSeleccionada?.label || datosPaciente.comuna || "-" },
    ];

    return (
        <div className="card shadow-sm position-sticky" style={{ top: 16 }}>
            <div className="card-header bg-white fw-bold">Resumen</div>
            <div className="card-body p-3">
                {items.map((item) => (
                    <div className="mb-3" key={item.label}>
                        <div className="text-muted small">{item.label}</div>
                        <div className="fw-semibold text-dark" style={{ lineHeight: 1.2 }}>{item.value}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

const FormPacienteInicial = ({ id, onSaved }) => {
    const { pacienteID: paramsID } = useParams();
    const pacienteID = id || paramsID;

    const [datosDias, setdatosDias] = useState([]);
    const [cantidadDias, setCantidadDias] = useState(0)
    const [turnoID, setTurnoID] = useState(null);
    const [showHorasTurnoModal, setShowHorasTurnoModal] = useState(false);


    const daysOfWeek = [
        { value: 1, label: "Lunes" },
        { value: 2, label: "Martes" },
        { value: 3, label: "Miércoles" },
        { value: 4, label: "Jueves" },
        { value: 5, label: "Viernes" },
        { value: 6, label: "Sábado" },
        { value: 7, label: "Domingo" },
    ];

    const toggleDay = (day) => {
        setdatosDias((prev) =>
            prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
        );
    };

    const [datosPaciente, setDatosPaciente] = useState({
        id: 0,
        rut: "",
        nombres: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        fechaNacimiento: "",
        direccion: "",
        como_llegar: "",
        comuna: "",
        diagnostico: "",
        contrato_sk: "0",
        tipoTurno: "",
        horaInicio: "",
        horaFin: "",
        sector: "",
        viveFueraSantiago: false,
        requiereVisita: true,
        observacionVisita: "",
        correosNotificacion: "",
        tipo_cobro_adicional_default: 1
    });

    const [datosTutorPago, setDatosTutorPago] = useState({
        rut: "",
        nombres: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        relacion: "",
        correo: "",
        celular: "",
        fechaInicioServicio: "",
        duracionServicio: "",
        utilizarTutorPaciente: 0
    });

    const [datosTutorPaciente, setDatosTutorPaciente] = useState({
        rut: "",
        nombres: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        relacion: "",
        correo: "",
        celular: "",
        fechaInicioServicio: "",
        duracionServicio: "",
    });

    const [datosValoresServicios, setDatosValoresServicios] = useState({
        valorTurnoPaciente: 0,
        valorTurnoBasePaciente: 0,
        valorTurnoAlternativoPaciente: 0,
        tipoValorAlternativoPaciente: 0,
        valorColacionPaciente: 0,
        valorLocomocionPaciente: 0,
        valorOtroPaciente: 0,
        valorTurnoAuxiliar: 0,
        valorTurnoBaseAuxiliar: 0,
        valorColacionAuxiliar: 0,
        valorLocomocionAuxiliar: 0,
        valorOtroAuxiliar: 0
    });

    const [datosFacturacion, setDatosFacturacion] = useState({
        facturarA: "paciente",
        razonSocial: "",
        rut: "",
        giro: GLOSA_DEFAULT,
        direccion: "",
        comuna: "",
        email: ""
    });

    const resetForm = () => {
        setdatosDias([]);
        setCantidadDias(0);

        setDatosPaciente({
            rut: "",
            nombres: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            fechaNacimiento: "",
            direccion: "",
            como_llegar: "",
            comuna: "",
            diagnostico: "",
        contrato_sk: "0",
            tipoTurno: "",
            horaInicio: "",
            horaFin: "",
            sector: "",
            viveFueraSantiago: false,
            requiereVisita: true,
            observacionVisita: "",
            correosNotificacion: ""
        });

        setDatosTutorPago({
            rut: "",
            nombres: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            relacion: "",
            correo: "",
            celular: "",
            fechaInicioServicio: "",
            duracionServicio: "",
            utilizarTutorPaciente: 0
        });

        setDatosTutorPaciente({
            rut: "",
            nombres: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            relacion: "",
            correo: "",
            celular: "",
            fechaInicioServicio: "",
            duracionServicio: "",
        });

        setDatosValoresServicios({
            valorTurnoPaciente: 0,
            valorTurnoBasePaciente: 0,
            valorTurnoAlternativoPaciente: 0,
            tipoValorAlternativoPaciente: 0,
            valorColacionPaciente: 0,
            valorLocomocionPaciente: 0,
            valorOtroPaciente: 0,
            valorTurnoAuxiliar: 0,
            valorTurnoBaseAuxiliar: 0,
            valorColacionAuxiliar: 0,
            valorLocomocionAuxiliar: 0,
            valorOtroAuxiliar: 0
        });

        setDatosFacturacion({
            facturarA: "paciente",
            razonSocial: "",
            rut: "",
            giro: GLOSA_DEFAULT,
            direccion: "",
            comuna: "",
            email: ""
        });
        setTemplateSelected(null);
    };


    const [comunas, setComunas] = useState([]);

    // Cargar las comunas desde el backend
    useEffect(() => {
        const fetchData = async () => {
            try {
                gdAlertify.showLoader()
                const response = await axiosInstance.get("/params/comunas");
                if (response.data && !response.data.error) {
                    setComunas(response.data.comunas.map(comuna => ({
                        value: comuna.id,
                        label: comuna.nombre
                    })));
                } else {
                    gdAlertify.notiError("No se pudieron cargar las comunas.");
                }

                if (pacienteID) {
                    const pacienteResponse = await axiosInstance.get("/paciente/busqueda", {
                        params: { id: pacienteID }
                    });
                    console.log(pacienteResponse);
                    if (pacienteResponse.data && !pacienteResponse.data.error && pacienteResponse.data.data.length > 0) {
                        const pacienteData = pacienteResponse.data.data[0];

                        // Cargar datos del paciente
                        setDatosPaciente({
                            id: pacienteData.id || 0,
                            rut: pacienteData.rut || "",
                            nombres: pacienteData.nombres || "",
                            apellidoPaterno: pacienteData.apellidoPaterno || "",
                            apellidoMaterno: pacienteData.apellidoMaterno || "",
                            fechaNacimiento: pacienteData.fechaNacimiento || "",
                            fecha_ingreso_sk: pacienteData.fecha_ingreso_sk || "",
                            direccion: pacienteData.direccion || "",
                            como_llegar: pacienteData.como_llegar || "",
                            comuna: pacienteData.comuna ? parseInt(pacienteData.comuna) : "",
                            diagnostico: pacienteData.diagnostico || "",
                            contrato_sk: String(Number(pacienteData.contrato_sk) === 1 ? 1 : 0),
                            tipoTurno: pacienteData.tipoTurno || "",
                            horaInicio: pacienteData.horaInicio || "",
                            horaFin: pacienteData.horaFin || "",
                            sector: pacienteData.sector || "",
                            viveFueraSantiago: pacienteData.vive_fuera_santiago == 1,
                            requiereVisita: pacienteData.requiere_visita == null ? true : pacienteData.requiere_visita == 1,
                            observacionVisita: pacienteData.observacion_visita || "",
                            correosNotificacion: pacienteData.correos_notificacion || "",
                            tipo_cobro_adicional_default: pacienteData.tipo_cobro_adicional_default || 1
                        });

                        // Procesar tutores
                        if (pacienteData.tutores?.length > 0) {
                            const tutorPago = pacienteData.tutores.find(t => t.tipo_tutor === 1 || t.tipo_tutor === 3);
                            const tutorSalud = pacienteData.tutores.find(t => t.tipo_tutor === 2 || t.tipo_tutor === 3);

                            // Tutor de pago (tipo 1 o 3)
                            if (tutorPago) {
                                setDatosTutorPago({
                                    rut: tutorPago.rut || "",
                                    nombres: tutorPago.nombres || "",
                                    apellidoPaterno: tutorPago.apellidoPaterno || "",
                                    apellidoMaterno: tutorPago.apellidoMaterno || "",
                                    relacion: tutorPago.relacion || "",
                                    correo: tutorPago.correo || "",
                                    celular: tutorPago.celular || "",
                                    fechaInicioServicio: tutorPago.fechaInicioServicio || "",
                                    duracionServicio: tutorPago.duracionServicio || "",
                                    utilizarTutorPaciente: (tutorSalud && tutorSalud.tipo_tutor === 2) ? 1 : 0 // 1 si hay tutor salud (Si), 0 si no (No)
                                });
                            }

                            // Tutor de salud (tipo 2 o 3)
                            if (tutorSalud && tutorSalud.tipo_tutor !== 3) { // Solo si es tipo 2 (si es 3 ya está en tutorPago)
                                setDatosTutorPaciente({
                                    rut: tutorSalud.rut || "",
                                    nombres: tutorSalud.nombres || "",
                                    apellidoPaterno: tutorSalud.apellidoPaterno || "",
                                    apellidoMaterno: tutorSalud.apellidoMaterno || "",
                                    relacion: tutorSalud.relacion || "",
                                    correo: tutorSalud.correo || "",
                                    celular: tutorSalud.celular || "",
                                    fechaInicioServicio: tutorSalud.fechaInicioServicio || "",
                                    duracionServicio: tutorSalud.duracionServicio || ""
                                });
                            }
                        }

                        // Cargar valores de servicios
                        if (pacienteData.valoresServicio?.length > 0) {
                            setDatosValoresServicios({
                                valorTurnoPaciente: pacienteData.valoresServicio[0].valorTurnoPaciente || 0,
                                valorTurnoBasePaciente: pacienteData.valoresServicio[0].valorTurnoBasePaciente || 0,
                                valorTurnoAlternativoPaciente: pacienteData.valoresServicio[0].valorTurnoAlternativoPaciente || 0,
                                tipoValorAlternativoPaciente: pacienteData.valoresServicio[0].tipoValorAlternativoPaciente || 0,
                                valorColacionPaciente: pacienteData.valoresServicio[0].valorColacionPaciente || 0,
                                valorLocomocionPaciente: pacienteData.valoresServicio[0].valorLocomocionPaciente || 0,
                                valorOtroPaciente: pacienteData.valoresServicio[0].valorOtroPaciente || 0,
                                valorTurnoAuxiliar: pacienteData.valoresServicio[0].valorTurnoAuxiliar || 0,
                                valorTurnoBaseAuxiliar: pacienteData.valoresServicio[0].valorTurnoBaseAuxiliar || 0,
                                valorColacionAuxiliar: pacienteData.valoresServicio[0].valorColacionAuxiliar || 0,
                                valorLocomocionAuxiliar: pacienteData.valoresServicio[0].valorLocomocionAuxiliar || 0,
                                valorOtroAuxiliar: pacienteData.valoresServicio[0].valorOtroAuxiliar || 0
                            });
                        }

                        // Cargar datos de facturación. Si el paciente ya tenía un registro
                        // (antes de que existiera "Facturar A"), se asume "Otro" para no
                        // pisar datos ya cargados a mano; si no tenía ninguno, "Paciente".
                        if (pacienteData.datosFacturacion?.length > 0) {
                            const df = pacienteData.datosFacturacion[0];
                            setDatosFacturacion({
                                facturarA: df.facturarA || "otro",
                                razonSocial: df.razonSocial || "",
                                rut: df.rut || "",
                                giro: df.giro || GLOSA_DEFAULT,
                                direccion: df.direccion || "",
                                comuna: df.comuna ? parseInt(df.comuna) : "",
                                email: df.email || ""
                            });
                        } else {
                            setDatosFacturacion(prev => ({ ...prev, facturarA: "paciente" }));
                        }

                        if (pacienteData.turnos) {
                            const turno = pacienteData.turnos;

                            setTurnoID(turno.id || null);
                            // Establece tipo de patrón
                            setPatternType(turno.type === "rotative" ? "rotative" : "fixed");

                            // Días de servicio
                            if (turno.days_service) {
                                setServiceDays(turno.days_service.split(","));
                            }

                            // Patrón rotativo
                            if (turno.type === "rotative") {
                                try {
                                    let parsedPattern = [];

                                    if (typeof turno.rotation_pattern === "string") {
                                        const raw = JSON.parse(turno.rotation_pattern);
                                        parsedPattern = Array.isArray(raw) ? raw : [raw];
                                    } else if (typeof turno.rotation_pattern === "object" && turno.rotation_pattern !== null) {
                                        parsedPattern = [turno.rotation_pattern];
                                    }

                                    setPatternRows(parsedPattern.map(p => {
                                        const esLibre = p.period === 'mixto' && (p.dailyPeriods || []).length > 0 && (p.dailyPeriods || []).every(d => d === 'libre');
                                        return {
                                            days: p.days || '',
                                            start: p.start || '',
                                            end: p.end || '',
                                            period: esLibre ? 'libre' : (p.period || 'day'),
                                            status: p.status || 'libre',
                                            dailyPeriods: (p.period === 'mixto' && !esLibre) ? (p.dailyPeriods || []) : [],
                                        };
                                    }));
                                } catch (e) {
                                    console.error("Error al interpretar rotation_pattern:", e);
                                }
                            }

                            // Patrón fijo
                            if (turno.type === "fixed") {
                                setPatternStartTime(turno.hora_inicio || "");
                                setPatternEndTime(turno.hora_fin || "");
                                setFixedPeriod(turno.period || "day");
                            }
                        }


                        // Cargar días del turno (si aplica)
                        if (pacienteData.diasTurno) {
                            setdatosDias(Array.isArray(pacienteData.diasTurno) ? pacienteData.diasTurno : []);
                        }

                    } else {
                        gdAlertify.notiError("No se pudieron cargar los datos del paciente.");
                    }
                    gdAlertify.hideLoader()
                } else {
                    gdAlertify.hideLoader()
                }
            } catch (error) {
                console.error(error);
                gdAlertify.notiError("Ocurrió un error al cargar los datos.");
            }
        };

        fetchData();
    }, [pacienteID]);


    const handleDatosValoresServicios = (e) => {
        const { name, value } = e.target;
        setDatosValoresServicios({
            ...datosValoresServicios,
            [name]: value,
        });
    };

    const handleChangeTutorPago = (e) => {
        const { name, value } = e.target;
        if (name === "rut") {
            const cleanedRut = cleanRut(value);
            setDatosTutorPago({ ...datosTutorPago, [name]: formatRut(cleanedRut) });
        } else {
            setDatosTutorPago({ ...datosTutorPago, [name]: value });
        }
    };

    const handleChangeTutorDoble = (selectedOption) => {
        if (selectedOption != null) {
            setDatosTutorPago({ ...datosTutorPago, utilizarTutorPaciente: selectedOption ? selectedOption.value : "" });
        }
    };

    const handleChangeFacturarA = (selectedOption) => {
        if (selectedOption != null) {
            setDatosFacturacion({ ...datosFacturacion, facturarA: selectedOption.value });
        }
    };

    const handleChangeTutorPaciente = (e) => {
        const { name, value } = e.target;
        if (name === "rut") {
            const cleanedRut = cleanRut(value);
            setDatosTutorPaciente({ ...datosTutorPaciente, [name]: formatRut(cleanedRut) });
        } else {
            setDatosTutorPaciente({ ...datosTutorPaciente, [name]: value });
        }
    };

    // Maneja el cambio en los campos del paciente
    const handleChangePaciente = (e) => {
        const { name, value } = e.target;
        if (name === "rut") {
            const cleanedRut = cleanRut(value);
            setDatosPaciente({ ...datosPaciente, [name]: formatRut(cleanedRut) });
        } else {
            setDatosPaciente({ ...datosPaciente, [name]: value });
        }
    };

    const handleComunaChange = (selectedOption) => {
        setDatosPaciente({ ...datosPaciente, comuna: selectedOption ? selectedOption.value : "" });
    };

    const handleComunaFacturacionChange = (selectedOption) => {
        setDatosFacturacion({ ...datosFacturacion, comuna: selectedOption ? selectedOption.value : "" });
    };

    const handleTurnoChange = (selectedOption) => {
        setDatosPaciente({ ...datosPaciente, tipoTurno: selectedOption ? selectedOption.value : "" });
        if (selectedOption?.value !== 7) {
            setCantidadDias(0);
        }
    };

    const handleChangeDatosFacturacion = (e) => {
        const { name, value } = e.target;
        if (name === "rut") {
            const cleanedRut = cleanRut(value);
            setDatosFacturacion({ ...datosFacturacion, [name]: formatRut(cleanedRut) });
        } else {
            setDatosFacturacion({ ...datosFacturacion, [name]: value });
        }
    };

    // Mientras "Facturar A" sea Paciente o Tutor, los datos de facturación se
    // mantienen sincronizados con esa fuente (siguen siendo editables a mano,
    // pero se re-completan cada vez que cambian los datos de origen). La Glosa
    // no se sincroniza: solo trae un valor por defecto al elegir Paciente/Tutor.
    useEffect(() => {
        // Email de notificación: tutor de pago -> tutor de salud -> primer
        // correo de "Correos de notificación" del paciente. Un solo email.
        const primerCorreoNotif = (datosPaciente.correosNotificacion || "").split(",").map(s => s.trim()).filter(Boolean)[0] || "";
        const emailNotificacion = (datosTutorPago.correo || "").trim() || (datosTutorPaciente.correo || "").trim() || primerCorreoNotif;

        if (datosFacturacion.facturarA === "paciente") {
            setDatosFacturacion(prev => ({
                ...prev,
                razonSocial: [datosPaciente.nombres, datosPaciente.apellidoPaterno, datosPaciente.apellidoMaterno].filter(Boolean).join(" "),
                rut: datosPaciente.rut,
                direccion: datosPaciente.direccion,
                comuna: datosPaciente.comuna,
                email: emailNotificacion,
            }));
        } else if (datosFacturacion.facturarA === "tutor") {
            setDatosFacturacion(prev => ({
                ...prev,
                razonSocial: [datosTutorPago.nombres, datosTutorPago.apellidoPaterno, datosTutorPago.apellidoMaterno].filter(Boolean).join(" "),
                rut: datosTutorPago.rut || "",
                direccion: datosPaciente.direccion,
                comuna: datosPaciente.comuna,
                email: datosTutorPago.correo || "",
            }));
        }
    }, [
        datosFacturacion.facturarA,
        datosPaciente.nombres, datosPaciente.apellidoPaterno, datosPaciente.apellidoMaterno,
        datosPaciente.rut, datosPaciente.direccion, datosPaciente.comuna, datosPaciente.correosNotificacion,
        datosTutorPago.nombres, datosTutorPago.apellidoPaterno, datosTutorPago.apellidoMaterno,
        datosTutorPago.rut, datosTutorPago.correo, datosTutorPaciente.correo,
    ]);

    const [startDate, setStartDate] = useState("");
    const [serviceDays, setServiceDays] = useState(['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']);            // ['Mon','Tue',...]
    const [skipInfo, setSkipInfo] = useState("Selecciona fecha y días para ver saltos.");
    const [patternName, setPatternName] = useState("");
    const [patternType, setPatternType] = useState("fixed");        // 'fixed' | 'rotative'
    const [fixedPeriod, setFixedPeriod] = useState("day");         // 'day' | 'night' | 'full' | 'off'
    const [patternRows, setPatternRows] = useState([]);             // [{ period, days }]
    const [patronesTemplates, setPatronesTemplates] = useState([]);
    const [templateSelected, setTemplateSelected] = useState(null);

    const daysMap = [
        { value: 'Mon', label: 'Lunes' },
        { value: 'Tue', label: 'Martes' },
        { value: 'Wed', label: 'Miércoles' },
        { value: 'Thu', label: 'Jueves' },
        { value: 'Fri', label: 'Viernes' },
        { value: 'Sat', label: 'Sábado' },
        { value: 'Sun', label: 'Domingo' }
    ];
    // Actualiza texto de skipInfo
    const updateSkipInfo = () => {
        if (!startDate || serviceDays.length === 0) {
            setSkipInfo('Selecciona fecha y días para ver saltos.');
            return;
        }
        const [sYear, sMonth, sDay] = startDate.split("-");
        const s = new Date(parseInt(sYear), parseInt(sMonth) - 1, parseInt(sDay));
        for (let i = 0; i < 7; i++) {
            const d = new Date(s);
            d.setDate(s.getDate() + i);
            const wd = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getDay()];
            if (serviceDays.includes(wd)) {
                setSkipInfo(i === 0 ? 'Inicia ese día.' : `Primer turno en ${i} día(s).`);
                return;
            }
        }
        setSkipInfo('No hay día marcado en la semana.');
    };

    useEffect(() => {
        setStartDate(datosTutorPago.fechaInicioServicio);
    }, [datosTutorPago.fechaInicioServicio]);

    useEffect(() => {
        const fetchTemplates = async () => {
            try {
                const response = await axiosInstance.get("/patrones-rotacion/listar");
                if (!response.data.error) {
                    setPatronesTemplates((response.data.data || []).map((p) => ({
                        value: p.id,
                        label: `${p.titulo} (${p.cantidad_auxiliares || 1} Auxiliares)`,
                        data: p
                    })));
                }
            } catch (error) {
                console.error("Error loading templates:", error);
            }
        };

        fetchTemplates();
    }, []);

    useEffect(() => {
        updateSkipInfo();
    }, [startDate, serviceDays]);

    const [diasOrdenadosUI, setDiasOrdenadosUI] = useState(['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']);
    useEffect(() => {
        if (datosTutorPago.fechaInicioServicio) {
            const nuevoOrden = ordenarDiasDesdeFecha(datosTutorPago.fechaInicioServicio);
            setDiasOrdenadosUI(nuevoOrden);
        }
    }, [datosTutorPago.fechaInicioServicio]);
    const ordenarDiasDesdeFecha = (fecha) => {
        const diasOrdenados = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
        const [year, month, day] = fecha.split("-");
        const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        let diaSemana = date.getDay(); // 0 = domingo, 1 = lunes, ..., 6 = sábado

        if (diaSemana === 0) diaSemana = 7; // domingo pasa a 7
        const idxInicio = diaSemana - 1;

        return [
            ...diasOrdenados.slice(idxInicio),
            ...diasOrdenados.slice(0, idxInicio)
        ];
    };

    // Manejadores para días de servicio
    const toggleServiceDay = (day) => {
        setServiceDays(prev =>
            prev.includes(day)
                ? prev.filter(d => d !== day)
                : [...prev, day]
        );
    };

    // Manejadores de patrón rotativo
    const addPatternRow = () => {
        setPatternRows(prev => [...prev, { period: 'day', days: '', start: '', end: '', status: 'libre', dailyPeriods: [] }]);
    };
    const removePatternRow = (index) => {
        setPatternRows(prev => prev.filter((_, i) => i !== index));
    };
    const handlePatternRowChange = (index, field, value) => {
        setPatternRows(prev => prev.map((row, i) => {
            if (i === index) {
                const updatedRow = { ...row, [field]: value };
                if (field === 'days' && updatedRow.period === 'mixto') {
                    const numDays = parseInt(value) || 0;
                    updatedRow.dailyPeriods = Array.from({ length: numDays }, (_, k) => row.dailyPeriods?.[k] || 'full');
                } else if (field === 'period' && value === 'mixto') {
                    const numDays = parseInt(row.days) || 0;
                    updatedRow.dailyPeriods = Array.from({ length: numDays }, (_, k) => row.dailyPeriods?.[k] || 'full');
                }
                return updatedRow;
            }
            return row;
        }));
    };

    const handleDailyPeriodChange = (rowIndex, dayIndex, value) => {
        setPatternRows(prev => prev.map((row, i) => {
            if (i === rowIndex) {
                const newDailyPeriods = [...(row.dailyPeriods || [])];
                newDailyPeriods[dayIndex] = value;
                return { ...row, dailyPeriods: newDailyPeriods };
            }
            return row;
        }));
    };

    // "Libre" se guarda como un slot 'mixto' con todos sus días en 'libre'
    // (mismo formato que ya entiende el backend para un tramo de descanso),
    // para no tener que enseñarle a todo el sistema un período nuevo.
    const patternRowsParaGuardar = () => patternRows.map(row => {
        if (row.period === 'libre') {
            return {
                period: 'mixto',
                days: row.days,
                start: '',
                end: '',
                status: row.status || 'libre',
                dailyPeriods: Array.from({ length: parseInt(row.days) || 0 }, () => 'libre'),
            };
        }
        return row;
    });

    const [patternStartTime, setPatternStartTime] = useState("");
    const [patternEndTime, setPatternEndTime] = useState("");

    const applyPatternTemplate = () => {
        if (!templateSelected?.data) {
            gdAlertify.notiError("Debe seleccionar una plantilla.");
            return;
        }

        try {
            const template = templateSelected.data;
            const config = typeof template.configuracion === "string"
                ? JSON.parse(template.configuracion)
                : (template.configuracion || {});

            setPatternType(template.tipo || "fixed");
            setPatternStartTime(config.horaInicio || "");
            setPatternEndTime(config.horaFin || "");
            setServiceDays(Array.isArray(config.serviceDays) ? config.serviceDays : []);

            if (template.tipo === "rotative") {
                setPatternRows(Array.isArray(config.phases) ? config.phases : []);
            } else {
                setFixedPeriod(config.period || "day");
                setPatternRows([]);
            }

            gdAlertify.notiSuccess(`Plantilla "${template.titulo}" aplicada`);
        } catch (error) {
            console.error("Error applying template:", error);
            gdAlertify.notiError("No se pudo aplicar la plantilla seleccionada.");
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (datosTutorPago.rut && !validateRut(cleanRut(datosTutorPago.rut))) {
            gdAlertify.notiError("El RUT del tutor es inválido.");
            return false;
        }

        if (!validateRut(cleanRut(datosPaciente.rut))) {
            gdAlertify.notiError("El RUT del paciente es inválido.");
            return false;
        }

        // if (datosDias.length == 0) {
        //     gdAlertify.notiError("Falta seleccionar dias del turno.");
        //     return false;
        // }

        // if (datosPaciente.tipoTurno === 7 && cantidadDias <= 0) {
        //     gdAlertify.notiError("Debe ingresar una cantidad de días válida.");
        //     return false;
        // }

        if (!validateRut(cleanRut(datosFacturacion.rut))) {
            gdAlertify.notiError("El RUT de facturación es inválido.");
            return false;
        }

        gdAlertify.confirm({
            title: 'Registrar paciente inicial',
            message: '¿Está seguro de registrar paciente inicial?',
            onConfirm: async () => {
                try {

                    let turnos = {
                        id: turnoID,
                        horaInicio: patternStartTime,
                        horaFin: patternEndTime,
                        serviceDays,             // e.g. ['Mon','Wed','Fri']
                        pattern: {
                            name: patternName,
                            type: patternType,      // 'fixed' o 'rotative'
                            ...(patternType === 'fixed'
                                ? { period: fixedPeriod }            // sólo día, noche, full, off
                                : { phases: patternRowsParaGuardar() }) // array de { period, days }
                        }
                    }
                    console.log(turnos);
                    const response = await axiosInstance.post("/paciente/crear", {
                        datosPaciente,
                        datosTutorPago,
                        datosTutorPaciente,
                        datosValoresServicios,
                        datosFacturacion,
                        datosDias,
                        cantidadDias: datosPaciente.tipoTurno === 7 ? cantidadDias : null,
                        turnos,
                    });

                    if (!response.data.error) {
                        if (onSaved) {
                            onSaved(response.data);
                        } else {
                            gdAlertify.alertSuccess('Paciente y tutores actualizados');
                        }
                    } else {
                        gdAlertify.alertError(response.data.message);
                    }
                } catch (error) {
                    console.error(error);
                    gdAlertify.notiError("Ocurrió un error al conectar con el servidor.");
                }
            },
            onCancel: () => {
                gdAlertify.notify('Envío cancelado', 'error');
            }
        });
    };

    return (
        <div className="container-fluid mt-4">
            <div className="row g-3">
                <div className="col-lg-10">
                    <div className="card shadow">
                        <div className="card-body" style={{ maxHeight: "calc(100vh - 110px)", overflowY: "auto" }}>

                    <legend className="w-auto">Edición de Paciente</legend>
                    <form id="formPaciente" onSubmit={handleSubmit}>
                        <div className="row">
                            {/* Datos del Paciente */}
                            <div className="col-md-12">
                                <fieldset className="border p-3 mb-3">
                                    <legend className="w-auto">Datos Paciente</legend>
                                    <div className="row">
                                        {[
                                            { name: "rut", label: "RUT" },
                                            { name: "nombres", label: "Nombres" },
                                            { name: "apellidoPaterno", label: "Apellido Paterno" },
                                            { name: "apellidoMaterno", label: "Apellido Materno" },
                                            { name: "fechaNacimiento", label: "Fecha de Nacimiento", type: "date" },
                                            { name: "fecha_ingreso_sk", label: "Fecha de Ingreso SK", type: "date" },
                                            { name: "diagnostico", label: "Diagnóstico o Patología" },
                                        ].map((field) => (
                                            <div className="mb-3 col-md-6" key={field.name}>
                                                <label className="form-label">{field.label} <Requerido /></label>
                                                <input
                                                    type={field.type || "text"}
                                                    className="form-control"
                                                    name={field.name}
                                                    value={datosPaciente[field.name]}
                                                    onChange={handleChangePaciente}
                                                    required
                                                />
                                            </div>
                                        ))}
                                        {[
                                            { name: "direccion", label: "Dirección" },
                                        ].map((field) => (
                                            <div className="mb-3 col-md-6" key={field.name}>
                                                <label className="form-label">{field.label} <Requerido /></label>
                                                <input
                                                    type={field.type || "text"}
                                                    className="form-control"
                                                    name={field.name}
                                                    value={datosPaciente[field.name]}
                                                    onChange={handleChangePaciente}
                                                    required
                                                />
                                            </div>
                                        ))}
                                        <div className="mb-3 col-md-6">
                                            <label className="form-label" htmlFor="contrato_sk">Contrato con SK</label>
                                            <select
                                                id="contrato_sk"
                                                name="contrato_sk"
                                                className="form-select"
                                                value={datosPaciente.contrato_sk}
                                                onChange={handleChangePaciente}
                                            >
                                                <option value="0">No</option>
                                                <option value="1">S?</option>
                                            </select>
                                        </div>
                                        {/* Como llegar */}
                                        <div className="mb-3 col-md-8">
                                            <label className="form-label">Cómo llegar (Indicaciones)</label>
                                            <textarea
                                                className="form-control"
                                                name="como_llegar"
                                                rows="2"
                                                value={datosPaciente.como_llegar}
                                                onChange={handleChangePaciente}
                                                placeholder="Ej: Portón verde, llegar a paradero 4, etc."
                                            ></textarea>
                                        </div>
                                        {/* Comuna */}
                                        <div className="mb-3 col-md-6">
                                            <label className="form-label">Comuna</label>
                                            <Select
                                                options={comunas}
                                                value={comunas.find(option => parseInt(option.value) == parseInt(datosPaciente.comuna))}
                                                onChange={handleComunaChange}
                                                placeholder="Seleccione una comuna"
                                                isClearable
                                            />
                                        </div>
                                        <div className="mb-3 col-md-6">
                                            <label className="form-label">Sector</label>
                                            <Select
                                                options={sectorOptions}
                                                value={findSectorOption(datosPaciente.sector)}
                                                onChange={(option) => setDatosPaciente({
                                                    ...datosPaciente,
                                                    sector: option ? option.value : "",
                                                })}
                                                placeholder="Seleccione un sector"
                                                isClearable
                                            />
                                        </div>

                                        <div className="mb-3 col-md-6">
                                            <div className="form-check form-switch pt-4">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="viveFueraSantiago"
                                                    name="viveFueraSantiago"
                                                    checked={datosPaciente.viveFueraSantiago}
                                                    onChange={(e) => setDatosPaciente({ ...datosPaciente, viveFueraSantiago: e.target.checked })}
                                                />
                                                <label className="form-check-label" htmlFor="viveFueraSantiago">
                                                    Vive fuera de Santiago
                                                </label>
                                            </div>
                                        </div>
                                        <div className="mb-3 col-md-6">
                                            <div className="form-check form-switch pt-4">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="requiereVisita"
                                                    name="requiereVisita"
                                                    checked={datosPaciente.requiereVisita}
                                                    onChange={(e) => setDatosPaciente({ ...datosPaciente, requiereVisita: e.target.checked })}
                                                />
                                                <label className="form-check-label" htmlFor="requiereVisita">
                                                    Paciente requiere visita
                                                </label>
                                            </div>
                                        </div>
                                        <div className="mb-3 col-12">
                                            <label className="form-label" htmlFor="observacionVisita">Observación visita</label>
                                            <textarea
                                                id="observacionVisita"
                                                className="form-control"
                                                name="observacionVisita"
                                                rows="3"
                                                value={datosPaciente.observacionVisita}
                                                onChange={handleChangePaciente}
                                                placeholder="Ingrese indicaciones u observaciones para las visitas del paciente"
                                            />
                                        </div>
                                        <div className="mb-3 col-md-6">
                                            <label className="form-label">Cobro adicional por defecto <Requerido /></label>
                                            <select
                                                className="form-control"
                                                name="tipo_cobro_adicional_default"
                                                value={datosPaciente.tipo_cobro_adicional_default}
                                                onChange={handleChangePaciente}
                                                required
                                            >
                                                <option value={1}>Paga SK</option>
                                                <option value={2}>Paga familia</option>
                                            </select>
                                        </div>
                                        <div className="mb-3 col-md-6">
                                            <label className="form-label">Correos de notificación (separados por coma)</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="correosNotificacion"
                                                value={datosPaciente.correosNotificacion}
                                                onChange={handleChangePaciente}
                                                placeholder="ejemplo1@mail.com, ejemplo2@mail.com"
                                            />
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                            <div className="col-md-12">
                                <fieldset className="border p-3 mb-3">
                                    <legend className="w-auto">Datos Facturacion</legend>
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Facturar A</label>
                                            <Select
                                                options={facturaAOptions}
                                                value={facturaAOptions.find(option => option.value === datosFacturacion.facturarA)}
                                                onChange={handleChangeFacturarA}
                                                placeholder="Seleccione"
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        {[
                                            { name: "rut", label: "RUT Factura", required: true },
                                            { name: "razonSocial", label: "Nombre/Razon Social", required: true },
                                            { name: "direccion", label: "Direccion", required: true },
                                        ].map((field) => (
                                            <div className="mb-3 col-md-4" key={field.name}>
                                                <label className="form-label">{field.label}{field.required && <> <Requerido /></>}</label>
                                                <input
                                                    type={field.type || "text"}
                                                    className="form-control"
                                                    name={field.name}
                                                    value={datosFacturacion[field.name]}
                                                    onChange={handleChangeDatosFacturacion}
                                                    {...(field.required && { required: true })}
                                                />
                                            </div>
                                        ))}
                                        <div className="mb-3 col-md-4">
                                            <label className="form-label">Comuna</label>
                                            <Select
                                                options={comunas}
                                                value={comunas.find(option => parseInt(option.value) == parseInt(datosFacturacion.comuna))}
                                                onChange={handleComunaFacturacionChange}
                                                placeholder="Seleccione una comuna"
                                                isClearable
                                            />
                                        </div>
                                        <div className="mb-3 col-md-4">
                                            <label className="form-label">Glosa</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="giro"
                                                value={datosFacturacion.giro}
                                                onChange={handleChangeDatosFacturacion}
                                            />
                                            <div className="form-text" style={{ fontSize: "0.7rem" }}>
                                                Variables: <code>{"{periodo}"}</code> → AGOSTO 2026, <code>{"{fecha_inicio}"}</code> → 26-07-2026, <code>{"{fecha_fin}"}</code> → 25-08-2026
                                            </div>
                                        </div>
                                        <div className="mb-3 col-md-4">
                                            <label className="form-label">Email factura</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                name="email"
                                                value={datosFacturacion.email}
                                                onChange={handleChangeDatosFacturacion}
                                            />
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                            {/* Datos del Tutor */}
                            <div className="col-md-12">
                                <fieldset className="border p-3 mb-3">
                                    <legend className="w-auto">Datos Tutor Pago</legend>
                                    <div className="row">
                                        {[
                                            { name: "rut", label: "RUT", required: false },
                                            { name: "nombres", label: "Nombres", required: false },
                                            { name: "apellidoPaterno", label: "Apellido Paterno", required: false },
                                            { name: "apellidoMaterno", label: "Apellido Materno", required: false },
                                            { name: "relacion", label: "Relación o Parentesco con Paciente", required: false },
                                            { name: "correo", label: "Correo Electrónico", type: "email", required: false },
                                            { name: "celular", label: "Celular de Contacto", type: "tel", required: false },
                                        ].map((field) => (
                                            <div className="mb-3 col-md-6" key={field.name}>
                                                <label className="form-label">{field.label}{field.required && <> <Requerido /></>}</label>
                                                <input
                                                    type={field.type || "text"}
                                                    className="form-control"
                                                    name={field.name}
                                                    value={datosTutorPago[field.name]}
                                                    onChange={handleChangeTutorPago}
                                                    {...(field.required && { required: false })}
                                                />
                                            </div>
                                        ))}
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Tiene otro tutor</label>
                                            <Select
                                                options={usoTutorPacienteOptions}
                                                value={usoTutorPacienteOptions.find(option => option.value == datosTutorPago.utilizarTutorPaciente)}
                                                onChange={handleChangeTutorDoble}
                                                placeholder="Seleccione"
                                                isClearable
                                            />
                                        </div>

                                    </div>
                                </fieldset>
                            </div>
                            {/* Datos del TutorPaciente */}
                            {datosTutorPago["utilizarTutorPaciente"] == 1 && (
                                <div className="col-md-12">
                                    <fieldset className="border p-3 mb-3">
                                        <legend className="w-auto">Datos Tutor Salud</legend>
                                        <div className="row">
                                            {[
                                                { name: "nombres", label: "Nombres", required: false },
                                                { name: "apellidoPaterno", label: "Apellido Paterno", required: false },
                                                { name: "apellidoMaterno", label: "Apellido Materno", required: false },
                                                { name: "relacion", label: "Relación o Parentesco con Paciente", required: false },
                                                { name: "correo", label: "Correo Electrónico", type: "email", required: false },
                                                { name: "celular", label: "Celular de Contacto", type: "tel", required: false },
                                            ].map((field) => (
                                                <div className="mb-3 col-md-6" key={field.name}>
                                                    <label className="form-label">{field.label}{field.required && <> <Requerido /></>}</label>
                                                    <input
                                                        type={field.type || "text"}
                                                        className="form-control"
                                                        name={field.name}
                                                        value={datosTutorPaciente[field.name]}
                                                        onChange={handleChangeTutorPaciente}
                                                        {...(field.required && { required: false })}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </fieldset>
                                </div>
                            )}

                            {/* Datos de turnos */}
                            <div className="col-md-12">
                                <fieldset className="border p-3 mb-3">
                                    <div className="row align-items-end mb-3">
                                        <div className="col-md-8">
                                            <label className="form-label">Patrones-Rotacion (Template)</label>
                                            <Select
                                                options={patronesTemplates}
                                                placeholder="Seleccionar plantilla..."
                                                isClearable
                                                value={templateSelected}
                                                onChange={setTemplateSelected}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary w-100"
                                                onClick={applyPatternTemplate}
                                                disabled={!templateSelected}
                                            >
                                                Aplicar
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Fecha de Inicio Rotación <Requerido /></label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="fechaInicioServicio"
                                            value={datosTutorPago["fechaInicioServicio"]}
                                            onChange={handleChangeTutorPago}
                                            required
                                        />
                                    </div>

                                    <legend className="w-auto">Patrón</legend>
                                    <div className="form-group">
                                        <label>Días de turno</label><br />
                                        <div className="col-md-12 mb-3 row">

                                            {diasOrdenadosUI.map(code => {
                                                const day = daysMap.find(d => d.value === code);
                                                return (
                                                    <div key={day.value} className="col-md-1">
                                                        <label className="form-label" htmlFor={day.value}>
                                                            {day.label}
                                                        </label>
                                                        <br />
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={`svc-${day.value}`}
                                                            value={day.value}
                                                            checked={serviceDays.includes(day.value)}
                                                            onChange={() => toggleServiceDay(day.value)}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                    <hr />
                                    <h4>Patrón de turno</h4>
                                    <div className="form-group">
                                        <label>Tipo</label><br />
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input
                                                type="radio"
                                                id="fixed"
                                                name="patternType"
                                                value="fixed"
                                                className="form-check-input"
                                                checked={patternType === 'fixed'}
                                                onChange={() => setPatternType('fixed')}
                                            />
                                            <label className="custom-control-label" htmlFor="fixed">Fijo</label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input
                                                type="radio"
                                                id="rotative"
                                                name="patternType"
                                                value="rotative"
                                                className="form-check-input"
                                                checked={patternType === 'rotative'}
                                                onChange={() => setPatternType('rotative')}
                                            />
                                            <label className="custom-control-label" htmlFor="rotative">Rotativo</label>
                                        </div>
                                    </div>

                                    {patternType === 'fixed' ? (
                                        <div className="form-group" id="fixed-options">
                                            <label>Periodo Fijo</label>
                                            <select
                                                className="form-control"
                                                value={fixedPeriod}
                                                onChange={e => setFixedPeriod(e.target.value)}
                                            >
                                                <option value="day">Sólo Día</option>
                                                <option value="night">Sólo Noche</option>
                                                <option value="full">Día y Noche</option>
                                            </select>
                                            <div className="row">
                                                {/* Hora inicio */}
                                                <div className="col-md-4 mb-3">
                                                    <label>Hora Inicio Turno <Requerido /></label>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        value={patternStartTime}
                                                        onChange={e => setPatternStartTime(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                                {/* Hora fin */}
                                                <div className="col-md-4 mb-3">
                                                    <label>Hora Fin Turno <Requerido /></label>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        value={patternEndTime}
                                                        onChange={e => setPatternEndTime(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="form-group" id="rotative-options">
                                            <label>
                                                Patrón de Rotación
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-primary ml-2"
                                                    onClick={addPatternRow}
                                                >
                                                    Añadir Fase
                                                </button>
                                            </label>
                                            <div id="pattern-container">
                                                {patternRows.map((row, idx) => (
                                                    <div key={idx} className="pattern-row row g-2 mb-2 p-2 border-bottom">
                                                        <div className="col-md-3 mb-2">
                                                            <label>Tipo</label>
                                                            <select
                                                                className="form-control"
                                                                value={row.period}
                                                                onChange={e => handlePatternRowChange(idx, 'period', e.target.value)}
                                                            >
                                                                <option value="day">Día</option>
                                                                <option value="night">Noche</option>
                                                                <option value="full">Día y Noche</option>
                                                                <option value="mixto">Mixto</option>
                                                                <option value="libre">Libre / Descanso</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-2 mb-2">
                                                            <label>Cantidad de dias <Requerido /></label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                min="1"
                                                                placeholder="Número de días"
                                                                required
                                                                value={row.days}
                                                                onChange={e => handlePatternRowChange(idx, 'days', e.target.value)}
                                                            />
                                                        </div>
                                                        {/* Hora inicio */}
                                                        <div className="col-md-2 mb-2">
                                                            <label>Hora Inicio Turno <Requerido /></label>
                                                            <input
                                                                type="time"
                                                                className="form-control"
                                                                value={row.start}
                                                                onChange={e => handlePatternRowChange(idx, 'start', e.target.value)}
                                                                required
                                                            />
                                                        </div>
                                                        {/* Hora fin */}
                                                        <div className="col-md-2 mb-2">
                                                            <label>Hora Fin Turno <Requerido /></label>
                                                            <input
                                                                type="time"
                                                                className="form-control"
                                                                value={row.end}
                                                                onChange={e => handlePatternRowChange(idx, 'end', e.target.value)}
                                                                required
                                                            />
                                                        </div>
                                                        <div className="col-md-1 mb-2 d-flex align-items-end">
                                                            <label>Eliminar</label>
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger"
                                                                onClick={() => removePatternRow(idx)}
                                                            >
                                                                −
                                                            </button>
                                                        </div>
                                                        {row.period === 'mixto' && (
                                                            <div className="col-12 mt-1">
                                                                <div className="d-flex flex-wrap gap-2 align-items-center bg-light px-2 py-1 rounded" style={{ borderLeft: '3px solid #0d6efd' }}>
                                                                    <span className="small fw-bold text-primary me-2"><i className="bi bi-gear-fill me-1"></i>Mixto:</span>
                                                                    {Array.from({ length: parseInt(row.days) || 0 }).map((_, dayIdx) => (
                                                                        <div key={dayIdx} className="d-flex align-items-center mb-1 mt-1">
                                                                            <span className="small text-muted me-1" style={{fontSize: '0.75rem'}}>D{dayIdx + 1}:</span>
                                                                            <select
                                                                                className="form-control form-control-sm border-primary"
                                                                                style={{ width: '100px', fontSize: '0.75rem', padding: '0.1rem 0.5rem' }}
                                                                                value={row.dailyPeriods?.[dayIdx] || 'full'}
                                                                                onChange={e => handleDailyPeriodChange(idx, dayIdx, e.target.value)}
                                                                            >
                                                                                <option value="full">Día/Noche</option>
                                                                                <option value="day">Día</option>
                                                                                <option value="night">Noche</option>
                                                                                <option value="libre">Libre</option>
                                                                            </select>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </fieldset>
                            </div>



                            {/* Duración del turno (horas por día) */}
                            <div className="col-12 mb-3">
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={() => setShowHorasTurnoModal(true)}
                                    disabled={!pacienteID}
                                >
                                    <i className="bi bi-clock-history me-1"></i>
                                    Configurar horas por turno (12h por defecto)
                                </button>
                            </div>
                            {/* Datos de los Servicios del Paciente y Auxiliar */}
                            <div className="col-md-6">
                                <fieldset className="border p-3 mb-3">
                                    <legend className="w-auto">Valor servicio familia</legend>
                                    <div className="row">
                                        {[
                                            { name: "valorTurnoPaciente", label: "Valor turno", required: true },
                                            { name: "valorTurnoBasePaciente", label: "Valor turno Base", required: true },
                                            { name: "valorColacionPaciente", label: "Valor colación", required: true },
                                            { name: "valorLocomocionPaciente", label: "Valor locomoción", required: true },
                                            { name: "valorOtroPaciente", label: "Valor otro", required: true },
                                        ].map((field) => (
                                            <div className="mb-3" key={field.name}>
                                                <label className="form-label">{field.label}</label>
                                                <input
                                                    type={field.type || "number"}
                                                    className="form-control"
                                                    name={field.name}
                                                    value={datosValoresServicios[field.name]}
                                                    onChange={handleDatosValoresServicios}
                                                />
                                            </div>
                                        ))}
                                        <div className="mb-3">
                                            <label className="form-label">Valor turno alternativo</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="valorTurnoAlternativoPaciente"
                                                value={datosValoresServicios.valorTurnoAlternativoPaciente}
                                                onChange={handleDatosValoresServicios}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Tipo valor alternativo</label>
                                            <select
                                                className="form-control"
                                                name="tipoValorAlternativoPaciente"
                                                value={datosValoresServicios.tipoValorAlternativoPaciente}
                                                onChange={handleDatosValoresServicios}
                                            >
                                                <option value={0}>Normal</option>
                                                <option value={1}>Fuera de santiago</option>
                                                <option value={2}>Fin de semana</option>
                                                <option value={3}>Fuera de santiago noches 50%</option>
                                            </select>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                            <div className="col-md-6">
                                <fieldset className="border p-3 mb-3">
                                    <legend className="w-auto">Valor servicio auxiliar</legend>
                                    <div className="row">
                                        {[
                                            { name: "valorTurnoAuxiliar", label: "Valor turno", required: true },
                                            { name: "valorTurnoBaseAuxiliar", label: "Valor Base turno", required: true },
                                            { name: "valorColacionAuxiliar", label: "Valor colación", required: true },
                                            { name: "valorLocomocionAuxiliar", label: "Valor locomoción", required: true },
                                            { name: "valorOtroAuxiliar", label: "Valor otro", required: true },
                                        ].map((field) => (
                                            <div className="mb-3" key={field.name}>
                                                <label className="form-label">{field.label}{field.required && <> <Requerido /></>}</label>
                                                <input
                                                    type={field.type || "number"}
                                                    className="form-control"
                                                    name={field.name}
                                                    value={datosValoresServicios[field.name]}
                                                    onChange={handleDatosValoresServicios}
                                                    {...(field.required && { required: true })}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                        <div className="text-center mt-4">
                            <button type="submit" className="btn btn-primary">
                                Guardar Cambios
                            </button>
                        </div>
                    </form>

                    <HorasTurnoModal
                        isOpen={showHorasTurnoModal}
                        onClose={() => setShowHorasTurnoModal(false)}
                        pacienteId={pacienteID}
                        pacienteNombre={`${datosPaciente.nombres || ""} ${datosPaciente.apellidoPaterno || ""}`.trim()}
                    />

                        </div>
                    </div>
                </div>
                <div className="col-lg-2">
                    <PacienteResumen datosPaciente={datosPaciente} comunas={comunas} />
                    <div className="d-grid mt-3">
                        <button type="submit" form="formPaciente" className="btn btn-primary">
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FormPacienteInicial;
